import { SB } from '@play-co/replicant';

const todayCounterSchema = SB.object({
  datestamp: SB.int().default(0),
  count: SB.int().default(0),
});

const analyticsPurchaseSchema = SB.object({
  absolute: SB.int().default(0),
  today: todayCounterSchema,
  absoluteByFeature: SB.map(SB.int().default(0)),
  todayByFeature: SB.map(todayCounterSchema),
});

export const analyticsSchema = {
  analytics: SB.object({
    sequences: SB.object({
      iapSequenceByFeature: SB.map(SB.int()),
      adsSequenceByFeature: SB.map(SB.int()),
    }),
    purchases: SB.object({
      tapped: analyticsPurchaseSchema,
      failure: analyticsPurchaseSchema,
      success: analyticsPurchaseSchema,
      start: analyticsPurchaseSchema,
      end: analyticsPurchaseSchema,
      cancelledFeature: SB.map(SB.int()),
      cancelledToday: todayCounterSchema,
      schemaVersion: SB.string(), // Schema on installation
    }),
  }),
};

export type TodayCounter = SB.ExtractType<typeof todayCounterSchema>;
